import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { BrowserRouter  } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './store';
import { ConfigProvider} from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { App as AntdApp } from 'antd';
dayjs.locale('zh-cn');
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <BrowserRouter >
        {/* <ConfigProvider locale={zhCN} theme={{ token: { colorPrimary: '#17a2b8' } }}> */}
        <ConfigProvider locale={zhCN} theme={{
            components: {
                Input: {
                    colorTextDisabled: 'black',       // 禁用文字颜色
                    colorBgContainerDisabled: '#fff', // 禁用背景色（可选）
                },
                Table: {
                /* 这里是你的组件 token */
                cellFontSizeSM:'16px'
                },

            },
            }}>
            <AntdApp><App /></AntdApp>            
        </ConfigProvider>
        </BrowserRouter >
    </Provider>
);
